import React from "react";
import { createRoot } from "react-dom/client";
import CartPopup from "./components/cart-popup";

const $popupRoot = document.getElementById("cart-popup");
if ($popupRoot) {
    createRoot($popupRoot).render(<CartPopup />);
}
